export default "__VITE_PUBLIC_ASSET__8a408c8b__"